import * as cssVariables from 'cssVariables';

export default {
  container: {
    marginBottom: 40,
  },
  title: {
    fontWeight: cssVariables.fontWeights.bold,
    color: cssVariables.grey600,
    lineHeight: 1.14,
    fontSize: cssVariables.fontSizes.medium,
    width: '70%',
    margin: '0 0 20px 0',
  },
};
